/**
 * 病历模块路由配置
 *
 * @module clinical-record/routes
 */

import { RouteRecordRaw } from "vue-router";

/**
 * 病历模块路由
 */
export const clinicalRecordRoutes: RouteRecordRaw[] = [
  {
    path: "/clinical-record",
    name: "ClinicalRecord",
    component: () => import("./interfaces/views/MedicalRecordView.vue"),
    meta: {
      title: "病历管理（DDD）",
      requiresAuth: true,
      keepAlive: true,
      breadcrumb: ["首页", "病历管理"],
    },
  },
];

export default clinicalRecordRoutes;
